import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import Team from '@/views/team/Team.vue';
import { teamCalendarRoute } from './team/calendar.route';
import { teamCoachesRoute } from './team/coaches.route';
import { teamDetailsRoute } from './team/details.route';
import { teamExamsManageRoute } from './team/exam/examsManage.route';
import { teamExamConductContainerRoute } from './team/examConductContainer.route';
import { teamFeePresencesRoute } from './team/feePresences.route';
import { teamFeesContainerRoute } from './team/feesContainer.route';
import { teamPlayersContainerRoute } from './team/playersContainer.route';
import { teamPresencesRoute } from './team/presences.route';
import { teamSchedulesContainerRoute } from './team/schedulesContainer.route';

export const teamRoute = {
  path: ':teamId',
  component: Team,
  children: [
    teamCalendarRoute,
    teamDetailsRoute,
    teamCoachesRoute,
    teamPlayersContainerRoute,
    teamSchedulesContainerRoute,
    teamPresencesRoute,
    teamFeesContainerRoute,
    teamFeePresencesRoute,
    teamExamsManageRoute,
    teamExamConductContainerRoute
  ],
  meta: {
    authorized: true,
    breadcrumb: {
      title: 'breadcrumbs.teams.view',
      name: 'team'
    }
  },
  beforeEnter: (to: any, from: any, next: any) => {
    store.commit('team/setId', tryParseInt(to.params.teamId));
    store
      .dispatch('team/get')
      .then(team => {
        teamRoute.meta.breadcrumb.title = team.name;
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'messages.team.getError' }));
  }
};
